var _circle, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPlayBtn(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 82,
    height: 81,
    viewBox: "0 0 82 81",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 41.0181,
    cy: 40.1118,
    r: 40.1118,
    fill: "#F6F6F9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M51.5835 37.1996L37.8091 29.2414C37.4154 29.0084 36.967 28.8839 36.5095 28.8804C35.7903 28.8804 35.1006 29.1661 34.5921 29.6746C34.0836 30.1831 33.7979 30.8728 33.7979 31.5919V48.6716C33.798 49.1488 33.9259 49.6173 34.1684 50.0283C34.4109 50.4394 34.759 50.778 35.1767 51.0089C35.5943 51.2398 36.0662 51.3547 36.5432 51.3415C37.0203 51.3283 37.4851 51.1875 37.8893 50.9339L51.6798 42.2216C52.1086 41.9532 52.4605 41.5784 52.7014 41.1335C52.9422 40.6887 53.0637 40.1891 53.054 39.6833C53.0443 39.1776 52.9037 38.6829 52.646 38.2477C52.3883 37.8124 52.0223 37.4513 51.5835 37.1996Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayBtn);
export default __webpack_public_path__ + "static/media/playBtn.d7cec916560998f169a4ad57de3cb270.svg";
export { ForwardRef as ReactComponent };